import { z } from "zod";
import { captureBrowserEvent } from "../browser";

export const JobImpressionSourceSchema = z.enum([
  "map_click",
  "direct_visit",
  "list_click",
]);

export const JobImpressionEventSchema = z.object({
  job_id: z.string().min(1),
  organization_id: z.string().min(1),
  store_id: z.string().min(1).optional(),
  source: JobImpressionSourceSchema,
  is_authenticated: z.boolean(),
  user_type: z.enum(["employee", "employer", "anonymous"]),
});

export type JobImpressionSource = z.infer<typeof JobImpressionSourceSchema>;
export type JobImpressionEvent = z.infer<typeof JobImpressionEventSchema>;

export const JOB_IMPRESSION_EVENT_NAME = "job.impression" as const;

export function trackJobImpression(event: JobImpressionEvent) {
  const parsed = JobImpressionEventSchema.safeParse(event);
  if (!parsed.success) {
    return;
  }

  captureBrowserEvent(JOB_IMPRESSION_EVENT_NAME, parsed.data);
}
